<template>
  <header class="header">
    <div class="header-content content-1200 flex-start H100">
      <img class="icon cursor" src="@/assets/img/head/logo.png" alt="" @click="$router.push('/')">
      <div class="menu-list" v-if="tabsSwtich">
        <ul class="flex-start">
          <router-link class="item" to="/" exact>首页</router-link>
          <router-link class="item" to="/doc" exact-active-class="active">标准文档</router-link>
          <div class="item relative"
               :class="{'active':['/home/news/list','/home/activity'].indexOf($route.path) !== -1}">联盟动态
            <div class="subMenu">
              <div :class="{active: $route.path === '/home/news/list'}" @click="$router.push('/home/news/list')">
                联盟动态
              </div>
              <div :class="{active: $route.path === '/home/activity'}" @click="$router.push('/home/activity')">
                联盟活动
              </div>
            </div>
          </div>
          <router-link class="item" to="/home/union/service" exact>金标认证</router-link>
          <router-link class="item" to="/home/union/openness" exact>开放能力</router-link>
          <div class="item relative"
               :class="{'active':['/home/about','/home/join'].indexOf($route.path) !== -1}">加入我们
            <div class="subMenu">
              <div :class="{active: $route.path === '/home/about'}" @click="$router.push('/home/about')">关于我们</div>
              <div :class="{active: $route.path === '/home/join'}" @click="$router.push('/home/join')">加入我们</div>
            </div>
          </div>
          <router-link v-if="utils.isEmpty(accountInfo) && utils.getTerminal()=='pc'" class="item" to="/console">
            控制台
          </router-link>
        </ul>
      </div>
    </div>
    <div class="header-right absolute" v-if="tabsSwtich">
      <div class="header-search relative">
        <el-input placeholder="请输入关键字" v-model.trim="searchValue" ref="searchRef" @focus="handleFocus"
                  @blur="handleBlur" @input="debouncedSearch" @keyup.enter.native="handleRun">
          <i slot="prefix" class="el-input__icon el-icon-search" @mousedown.prevent="handleRun"></i>
        </el-input>
        <ul v-if="showResult" class="search-result">
          <template v-if="searchList.length">
            <li v-for="item in searchList" :key="item.id" :title="item.title" class="flex-nowrap flex-start"
                @click="handleDetail(item)">
              <span class="text ellipsis">{{ item.title }}</span>
              <span class="tag">{{ item.type === 1 ? 'pdf' : '资讯' }}</span>
            </li>
          </template>
          <li class="empty" v-else>暂无结果</li>
        </ul>
      </div>
      <template v-if="utils.isEmpty(accountInfo)">
        <div class="item user relative">{{ accountInfo.email }}
          <div class="subMenu">
            <!-- dataState:1-未完善 2-已完善 3-冻结 4-待审核 5-未通过 -->
            <template v-if="accountInfo.dataState==2">
              <!-- type:1-企业 2-个人 3-政府单位 -->
              <router-link to="/account/role/info" target="_blank">修改资料</router-link>
            </template>
            <template v-else>
              <router-link to="/account/perfect/status" target="_blank">修改资料</router-link>
            </template>
            <router-link to="/account/modify" target="_blank">修改账户邮箱</router-link>
            <router-link to="/account/password/change" target="_blank">修改密码</router-link>
            <div @click="logout">退出登录</div>
          </div>
        </div>
      </template>
      <template v-else>
        <router-link class="item" to="/account/login">登录/注册</router-link>
      </template>
    </div>
  </header>
</template>

<script>
import {singleAccountSever, singleHomeSever} from "@/common/api-config";
import {debounce} from 'lodash'

export default {

  created() {
    this.$store.dispatch("accountStore/updateAccountInfo", {}).then((res) => {
    }).catch((res) => {
    });// 每次页面都去后台拿用户信息，更新本地状态

    // 绑定搜索防抖函数
    this.debouncedSearch = debounce(this.actualSearch, 500);
  },
  data() {
    return {
      tabsSwtich: true,//是否展示tabs导航开关
      searchValue: '',
      showResult: false, // 是否展示搜索结果开关
      searchList: [],
      debouncedSearch: null
    };
  },
  computed: {
    accountInfo() {
      return this.$store.getters["accountStore/accountInfo"];//账户状态info
    },
  },
  watch: {
    '$route'(to) {
      this.tabsSwtich = to.path.indexOf('account') == -1;//账户模块不需要 tabs导航
    }
  },
  methods: {
    // 登出
    logout() {
      singleAccountSever.loginOut({
        token: this.accountInfo.token
      }).then(result => {
        if (result.code == 0) {
          localStorage.clear();
          this.$store.dispatch("accountStore/updateAccountInfo", {}).then(res => {//去后台拿账户信息，更新本地状态
          }).catch(() => {
          });
          this.$router.push('/');
        }
      });
    },
    handleFocus() {
      this.$refs.searchRef.$el.classList.add(('active'))
    },
    handleBlur() {
      this.$refs.searchRef.$el.classList.remove(('active'))
      setTimeout(() => {
        this.showResult = false
      }, 200)
    },
    // 搜索
    actualSearch(keyword) {
      if (!keyword) return;
      singleHomeSever.querySearchList({
        keyword,
      }).then(res => {
        if (res.code == 0) {
          this.searchList = res.data
          this.showResult = true;
        } else {
          this.searchList = []
          this.showResult = true;
        }
      })
    },
    // 跳转搜索页
    handleRun() {
      if (!this.searchValue) return;
      this.handleBlur()
      this.$router.push({path: '/home/search', query: {keyword: this.searchValue}})
    },
    handleDetail(item) {
      if (item.type === 1) {
        this.$router.push({path: `/doc/${item.id}`})
      } else {
        this.$router.push({path: '/home/news/info', query: {newsId: item.id}})
      }
    }
  },
  beforeDestroy() {
    this.debouncedSearch.cancel();
  }
};
</script>

<style scoped lang="scss">
.header {
  z-index:999;
  height: 64px;
  line-height: 64px;
  position: fixed;
  top: 0;
  width: 100%;
  font-size: 14px;
  background: #12151A;
  display: flex;
  flex-wrap: nowrap;

  .menu-list {
    width: calc(100vw - 800px);
    ul {
      width: 100%;
      //overflow: auto;
      //overflow-x: auto;
      //overflow-y: hidden;
      &::-webkit-scrollbar {
        height: 5px; /* 水平滚动条高度 */
        border-radius: 4px;
      }
      &::-webkit-scrollbar-track {
        background: #B2B2B2;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #F5CE99;
        border-radius: 4px;
      }
      & > a, & > div {
        flex-shrink: 0;
      }
    }
  }

  .icon {
    width: 200px;
    margin-right: 40px;
  }

  .item {
    color: #B2B2B2;
    cursor: pointer;
    margin-right: 40px;

    .subMenu {
      position: absolute;
      top: 64px;
      left: -29px;
      background-color: #fff;
      width: 140px;
      padding: 8px 0 12px;
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #E6E6E6;
      display: none;
      //display: flex;
      //flex-direction: column;

      & > div, & > a {
        display: block;
        height: 40px;
        line-height: 40px;
        padding-left: 20px;
        color: #666;
        font-weight: normal;

        &:hover, &.active {
          font-weight: bold;
          color: #CEC298;
        }
      }
    }

    &.active, &:hover, &.router-link-active {
      font-weight: bold;
      color: #CEC298;
    }

    &.user:hover {
      font-weight: normal;
    }

    &:hover .subMenu {
      //visibility: visible;
      display: block;
    }

  }

  &-right {
    right: 0;
    top: 0;
    display: flex;
    flex-wrap: nowrap;
    //输入框样式
    .el-input {
      width: 140px;
      margin-right: 40px;
      transition: width 0.3s;

      &.active {
        width: 240px;

        .el-input__prefix {
          left: 9px;
        }
      }

      /deep/ &__inner {
        height: 32px;
        line-height: 32px;
        font-size: 12px;
        color: $color-level4;
        background: #12151A;
        border-radius: 54px 54px 54px 54px;
        border: 1px solid #333333;

        &::placeholder {
          color: $color-level4;
        }
      }

      /deep/ &__prefix {
        color: #666;
        top: 1px;
        cursor: pointer;
      }
    }

    //搜索结果
    .search-result {
      width: 240px;
      max-height: 140px;
      overflow-y: auto;
      position: absolute;
      top: 64px;
      left: 0;
      background: #FFFFFF;
      border-radius: 4px;
      padding: 8px 0;
      z-index: 99;

      li {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        font-weight: bold;
        color: #666;
        cursor: pointer;

        &:hover {
          background: rgba(206, 194, 152, .1);
          color: #C5A020;
        }

        .text {
          display: inline-block;
        }

        .tag {
          display: inline-block;
          font-size: 12px;
          border: 1px solid #b2b2b2;
          border-radius: 2px;
          color: #b2b2b2;
          height: 18px;
          line-height: 18px;
          margin-left: 5px;
          min-width: 40px;
          text-align: center;
        }

        &.empty {
          height: 100px;
          line-height: 100px;
          text-align: center;
          cursor: default;

          &:hover {
            background: #fff;
            color: #666;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .header {
    height: auto;

    .subMenu {
      width: auto !important;
      padding: 4px 3px 6px !important;
      left: -4px !important;
      top: 46px !important;

      & > div, & > a {
        height: 24px !important;
        line-height: 24px !important;
        padding-left: 0 !important;
      }
    }

    &-content {
      flex-direction: column;
      align-items: start;

      .icon {
        margin: 10px;
      }

      .menu-list {
        max-width: 100%;
        width: 100%;
        border-top: .5px solid #f3eac2;

        ul {
          width: 100%;

          .item {
            margin-right: 0;
            flex: auto;
            text-align: center;
            .subMenu {
              font-size: 12px;
            }
          }
        }
      }
    }

    &-right {
      .header-search {
        display: none;
      }

      .item {
        height: auto;
        line-height: normal;
        margin-right: 8px;
        margin-top: 16px;
      }
    }
  }
}
</style>
